export const APP_CONST = Object.freeze({
  AUTH_ACTIONS: {
    LOGIN: "login",
    REGISTER: "register",
  },
  TOAST_TYPE: {
    ERROR: "error",
    SUCCESS: "success",
    INFO: "info",
    WARNING: "warning",
  },
  SPORTS_ID: {
    CIRCKET: "4",
    SOCCER: "1",
    TENNIS: "2",
  },
  ALL_MARKET_IDS: {
    CRICKET: "CRICKET_IDS",
    SOCCER: "SOCCER_IDS",
    TENNIS: "TENNIS_IDS",
  },
  ODDS_TYPE: {
    BACK: "back",
    LAY: "lay",
  },
  AUTH_MODAL: {
    LOGIN: "login",
    REGISTER: "register",
    MOBILE_NUMBER: "mobileNumber",
    VERIFY_NUMBER: "verifyNumber",
    FORGOTO_PASSWORD: "forgotpassword",
    RESET_PASSWORD: "resetpassword",
  },
  TEST: {},
  PLAYER_BANK_DETAILS_TYPE: {
    Bank: "bank",
    Card: "card",
  },
  ORGANISATION_STATUS: {
    Maintenance: "maintenance",
    Live: "live",
    Suspended: "suspended",
  },
});

export const WithdrawModes = Object.freeze({
  Bank: "bank",
  Netwallet: "netwallet",
  Upi: "upi",
});

export const DEFAULT_APP_ROUTES = Object.freeze({
  PUBLIC: "/",
  PROTECTED: "/home",
});

export const AppTheme = Object.freeze({
  Dark: "dark",
  Light: "light",
});

export const SportsLobbyProviders = {
  IgPixel: "ig_pixel",
};

export const PublicIgPixelUrl = "https://spex.igpxl.com/?sessionId=null";


export const INPUT_TYPE = {
  FILE: "file",
  TEXT: "text",
  DATE: "date",
};

export const KYC_DOC_TYPES = [
  {
    id: 0,
    name: "Passport",
    key: "passport",
    requiredBackSide: true,
    requiredDocId: true,
  },
  // { id: 1, name: "Emirates Id", key: "emiratesId", requiredBackSide: true },
  {
    id: 2,
    name: "Pancard",
    key: "pancard",
    requiredBackSide: false,
    requiredDocId: true,
  },
  {
    id: 3,
    name: "Adhar Card",
    key: "adharcard",
    requiredBackSide: true,
    requiredDocId: true,
  },
  {
    id: 4,
    name: "Driving License",
    key: "drivinglicense",
    requiredBackSide: false,
    requiredDocId: true,
  },
];

export const KYC_VERIFICATION_STATUS = Object.freeze({
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Expired: "expired",
});

export const MaxFileSize = 4000000; // 4 mb

export const AUTH_MODALS = Object.freeze({
  LOGIN: "login",
  REGISTER: "register",
  MOBILE_NUMBER: "mobileNumber",
  VERIFY_NUMBER: "verifyNumber",
  FORGOT_PASSWORD: "forgotpassword",
  RESET_PASSWORD: "resetpassword",
});

export const IS_MODAL_AUTH_INTERFACE = true;

export const APP_THEMES = {
  DARK: "dark",
  LIGHT: "light",
};

export const GTW_MODE = {
  Deposit: "deposit",
  Withdraw: "withdraw",
};

export const BankModeRequiredFields = [
  "accountNo",
  "accountName",
  "iban",
  "ifscCode",
  "bankName",
];
